import styled from 'styled-components';
import { colors } from "../../utils/colors";
import TopLineImg from '../../assets/home/top-line.svg'

export const Background = styled.div`
    position: relative;
    width: 100vw;
    min-height: 100vh;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 100px 60px 100px;

    @media (max-width: 1200px) {
            padding: 100px 40px 100px;
    }

    @media (max-width: 800px) {
            padding: 100px 20px 100px;
    }
`;

export const AbutUsGroups = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;
    margin-bottom: 80px;
    margin-top: 80px;
    
    @media (max-width: 800px) {
        grid-template-columns: 100%;
    }
`;

export const AboutUsGroupTitle = styled.h4`
    position: absolute;
    top: 20px;
    left: 30px;
    max-width: 170px;
    font-weight: bold;
    color: ${colors.DARK_BLUE};

    @media (max-width: 1200px) {
        left: 20px;
    }

    @media (max-width: 600px) {
        max-width: 150px;
        top: 10px;
        left: 10px;
    }

    @media (max-width: 450px) {
        font-size: 12px;
        max-width: 100px;
    }
`;

export const AbutUsHeader = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100px;
    overflow: hidden;
    background: url(${TopLineImg});
    background-repeat: no-repeat;
    background-size: cover;
`;

export const AbutUsTitle = styled.p`
    color: white;
    font-family: 'Courgette', cursive;
    position: absolute;
    top: 10px;
    left: 0;
    width: 100%;
    text-align: center;

`;

export const SplitWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    @media (max-width: 1200px) {
        flex-direction: column;
    }
`;

export const SplitDiv = styled.div`
    width: 50%;

    @media (max-width: 1200px) {
        width: 100%;
        text-align: ${props => props.centered ? 'center' : 'left'}
    }
`;

export const CreamLine = styled.p`
    font-family: 'Courgette', cursive;
    color: ${colors.CREAM};
`;

export const BlueText = styled.p`
    font-family: 'Markazi Text', serif;
    color: ${colors.BLUE};
`;